<template>
    <div>

        <label class="uk-form-label uk-text-bold">{{ property.name }}</label>

        <select v-if="propertyValues.length != 1" v-model="selectedPropertyValues" class="uk-select">
            <option selected disabled hidden style='display: none' value=''></option>
            <option v-for="PropertyValue in propertyValues"
                    :value="PropertyValue.id"
                    :key="PropertyValue.id"
                    :selected="propertyValues.length == 1">{{ PropertyValue.value_varchar }}
            </option>
        </select>
        <select v-else class="uk-select selected-property-value" disabled="disabled">
            <option v-for="PropertyValue in propertyValues"
                    :value="PropertyValue.id"
                    :key="PropertyValue.id"
            >{{ PropertyValue.value_varchar }}
            </option>
        </select>
    </div>

</template>

<script>
    export default {
        name: "PropertySelect",
        props: {
            property: {
                type: Object,
                required: true,
            },
            propertyValues: {
                type: Array,
                required: true,
            },
            selected: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        data() {
            return {}
        },
        computed: {
            selectedPropertyValues: {
                get() {
                    return this.selected
                },
                set(value) {
                    if (value === undefined) {
                        return 0;
                    } else {
                        this.$emit('property-value-selected', this.property, value)
                        return value;
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PropertySelect.vue?2ebec6f6